export const CONTENT_TYPE_LABELS: Record<string, string> = {
  'subsidiary-hero': 'Subsidiary Hero',
  'subsidiary-about': 'Subsidiary About',
  'subsidiary-highlights': 'Subsidiary Key Highlights',
  'subsidiary-solutions': 'Subsidiary Products & Services',
  'subsidiary-contact': 'Subsidiary Contact',
  'subsidiary-vision-mission': 'Subsidiary Vision & Mission',
  'subsidiary-cta': 'Subsidiary CTA',
}
